import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const useAdminProtected = () => {
    const { isAdmin } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!isAdmin) {
            navigate('/');
        }
    }, [isAdmin, navigate]);

    return isAdmin;
};

export const withAdminProtection = (WrappedComponent) => {
    return (props) => {
        const isAdmin = useAdminProtected();
        
        if (!isAdmin) {
            return null; // or a loading spinner, or unauthorized message
        }

        return <WrappedComponent {...props} />;
    };
};
